<template>
  <div class="">
    <!-- <transition name="slide" mode="out-in"> -->
    <loading pic="loading1" v-if="loadingState" key="1" />

    <div v-else class="lists__wrapper" key="2">
      <form method="post" @submit.prevent="addClient()" class="user__form">
        <h3 v-if="!getOneClient._id" class="new_item item__header">
          <svg
            version="1.0"
            width="30px"
            height="30px"
            viewBox="0 0 1280.000000 1237.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,1237.000000) scale(0.100000,-0.100000)"
              fill="var(--gold)"
              stroke="none"
            >
              <path
                d="M6008 11881 c30 -14 28 -29 -8 -49 -16 -9 -30 -20 -30 -24 0 -5 -9
              -8 -19 -8 -11 0 -21 -4 -23 -8 -7 -16 -206 -90 -261 -96 -32 -3 -72 -13 -89
              -22 -33 -17 -178 -132 -178 -141 0 -3 6 -1 13 4 90 72 187 134 122 79 -16 -14
              -32 -26 -35 -26 -3 0 -34 -31 -68 -70 -46 -51 -55 -65 -35 -55 34 18 39 13 18
              -19 -10 -14 -15 -33 -11 -41 4 -11 2 -14 -6 -9 -8 5 -9 2 -5 -10 4 -9 3 -15
              -2 -11 -5 3 -14 -10 -21 -29 -6 -19 -21 -45 -33 -58 -40 -41 -89 -108 -79
              -108 5 0 17 9 27 20 10 11 20 18 23 15 3 -2 13 0 23 6 25 13 24 4 -3 -34 -15
              -20 -22 -47 -23 -83 -1 -30 1 -51 6 -49 4 3 10 -5 14 -17 3 -13 17 -51 31 -85
              21 -51 24 -65 14 -83 -7 -13 -8 -20 -2 -16 20 12 21 -25 1 -61 l-21 -38 21 25
              c25 30 27 14 6 -45 -18 -50 -18 -50 0 -35 12 10 13 7 5 -21 -5 -17 -7 -35 -5
              -39 4 -7 -7 -86 -21 -149 -4 -20 -3 -22 8 -13 11 9 14 -8 15 -92 2 -57 7 -115
              13 -130 9 -23 7 -28 -15 -36 -51 -19 -58 -46 -53 -207 5 -170 14 -202 90 -336
              56 -98 86 -125 121 -110 21 10 23 6 45 -76 25 -94 70 -198 106 -246 47 -61 76
              -394 44 -495 -23 -71 -115 -185 -239 -297 -134 -121 -135 -122 -228 -168 -91
              -46 -184 -69 -357 -90 -178 -22 -269 -45 -371 -95 -175 -86 -285 -254 -337
              -515 -34 -173 -39 -263 -41 -700 -2 -470 -7 -550 -66 -1060 -34 -289 -67 -486
              -104 -618 -39 -138 -61 -173 -213 -344 -50 -56 -109 -126 -130 -155 -40 -54
              -211 -331 -341 -556 -152 -260 -460 -702 -489 -702 -4 0 -14 13 -23 29 -23 39
              -64 48 -100 22 -29 -21 -49 -27 -49 -14 0 4 7 27 17 51 15 40 15 46 0 77 -19
              41 -56 54 -94 34 -15 -8 -54 -47 -87 -86 -33 -40 -64 -73 -68 -73 -3 0 -21
              -12 -39 -27 -38 -32 -68 -95 -69 -142 0 -48 -56 -147 -108 -189 -24 -21 -56
              -48 -71 -62 -25 -24 -94 -49 -138 -50 -12 0 -30 8 -40 19 -58 60 -183 52 -183
              -12 0 -50 47 -124 105 -167 77 -57 119 -73 170 -65 23 3 62 1 86 -6 78 -20
              113 -21 182 -5 67 16 70 15 95 -4 22 -18 40 -21 121 -21 53 0 123 0 156 -1 33
              -1 75 2 93 6 19 5 32 5 32 -1 0 -5 -44 -27 -97 -48 -258 -100 -474 -237 -585
              -369 -63 -76 -139 -219 -163 -311 -23 -86 -30 -213 -16 -287 16 -80 66 -185
              131 -270 66 -87 241 -263 338 -340 90 -70 94 -74 67 -61 -24 12 -48 6 -39 -9
              4 -7 2 -8 -4 -4 -7 4 -25 -8 -42 -28 -19 -21 -37 -33 -46 -29 -8 3 -14 0 -14
              -7 0 -6 5 -8 11 -4 7 4 10 1 7 -7 -3 -8 -10 -13 -17 -12 -6 2 -13 -8 -17 -21
              -4 -17 -15 -27 -35 -31 -16 -4 -27 -11 -23 -16 3 -5 10 -6 16 -3 7 4 8 2 4 -5
              -4 -6 -12 -9 -17 -6 -5 4 -9 1 -9 -5 0 -7 -7 -9 -16 -6 -8 3 -12 2 -9 -3 3 -5
              1 -12 -5 -16 -5 -3 -10 -1 -10 6 0 21 -13 0 -15 -24 -1 -13 -8 -21 -17 -19 -8
              1 -20 -9 -26 -23 -7 -16 -17 -23 -27 -19 -18 7 -21 -12 -2 -20 6 -3 1 -3 -13
              1 -22 5 -23 4 -12 -10 15 -17 8 -37 -11 -37 -7 0 -6 4 3 11 13 9 13 10 0 6 -8
              -2 -15 -12 -15 -23 0 -10 -4 -25 -9 -33 -7 -10 -6 -12 4 -6 10 6 12 0 8 -23
              -5 -34 11 -48 32 -29 10 10 10 8 1 -9 -9 -19 -7 -24 15 -39 15 -9 24 -12 20
              -7 -3 6 13 1 36 -11 24 -12 44 -25 46 -29 2 -5 12 -3 22 2 15 8 17 6 13 -9 -3
              -14 1 -17 19 -16 13 1 25 -1 28 -6 3 -4 21 -10 40 -12 19 -3 35 -6 35 -7 0 -1
              17 -3 37 -5 21 -1 45 -9 55 -16 11 -9 14 -10 9 -2 -4 7 -2 13 3 13 6 0 11 -4
              11 -9 0 -10 34 -19 90 -25 19 -2 47 -8 62 -14 15 -6 60 -14 100 -18 40 -3 76
              -8 80 -11 33 -19 765 -18 1218 1 52 3 160 7 240 10 81 4 173 8 205 11 33 2
              101 7 150 10 50 3 108 8 130 10 22 2 87 7 145 10 58 4 119 8 135 10 29 4 111
              11 230 20 33 3 83 7 110 10 107 10 163 15 230 20 134 9 220 16 310 25 50 6
              218 19 375 30 157 11 314 22 350 25 36 2 112 7 170 9 58 3 159 9 225 13 66 3
              644 7 1285 8 641 1 1201 5 1245 10 44 4 117 8 162 9 46 0 83 3 83 6 0 3 17 5
              38 6 20 0 60 4 87 7 28 4 68 9 90 12 22 2 51 7 65 10 27 6 93 13 177 19 28 2
              56 6 60 9 5 3 38 8 74 11 63 6 124 14 164 23 11 2 38 6 60 8 22 3 56 7 75 10
              19 3 53 8 75 10 22 3 58 9 80 15 79 21 90 23 113 23 12 -1 22 3 22 8 0 5 9 9
              21 9 12 0 17 4 14 11 -4 6 2 13 14 16 12 3 21 8 21 12 0 3 13 21 29 39 19 21
              31 28 34 20 2 -7 5 4 5 25 0 32 -4 40 -26 48 -21 8 -23 12 -12 19 9 6 18 5 23
              -3 6 -8 7 -8 4 3 -2 8 -13 14 -25 14 -13 -1 -19 3 -15 13 3 7 -2 22 -11 32 -9
              10 -13 21 -9 26 5 4 -3 2 -16 -5 -13 -6 -21 -7 -17 -2 3 6 2 13 -4 17 -18 11
              -40 63 -34 79 3 9 10 13 15 10 5 -3 9 -2 8 3 -4 24 2 43 13 37 6 -4 8 -3 4 4
              -3 6 -2 14 4 17 6 4 8 15 5 25 -4 12 2 27 15 40 11 11 21 30 23 43 1 12 9 30
              19 40 16 19 78 129 78 141 0 3 -8 3 -17 0 -10 -3 4 8 31 24 77 47 250 188 363
              296 88 83 109 110 143 180 49 99 63 187 49 317 -16 158 -57 235 -204 385 -85
              86 -113 108 -185 143 -47 22 -122 51 -167 63 -63 18 -83 27 -83 40 0 31 -45
              51 -100 46 -27 -3 -47 -1 -44 4 3 4 26 8 52 8 31 0 59 8 82 22 22 13 54 22 85
              23 36 1 69 12 117 38 37 20 93 43 125 53 132 38 138 42 215 128 75 86 147 219
              134 251 -10 26 -53 36 -99 24 -38 -10 -107 -67 -107 -89 0 -4 -23 -23 -52 -41
              -39 -25 -75 -38 -140 -50 -49 -8 -90 -14 -92 -12 -2 2 3 26 12 52 l15 49 -86
              179 c-103 217 -179 333 -219 333 -17 0 -35 -10 -52 -31 -28 -33 -32 -53 -16
              -94 9 -25 9 -26 -12 -18 -37 13 -208 6 -276 -11 -34 -9 -98 -32 -140 -51 -141
              -62 -147 -62 -271 0 -172 86 -400 263 -925 714 -325 280 -343 294 -486 396
              -146 104 -224 178 -250 238 -10 23 -28 95 -40 160 -11 64 -27 145 -34 179 -23
              98 -43 248 -80 578 -52 456 -56 535 -54 900 2 232 -1 366 -10 435 -39 297
              -105 469 -226 590 -111 111 -241 162 -496 195 -85 11 -184 27 -220 36 -105 26
              -216 85 -303 161 -43 37 -101 88 -130 112 -54 46 -145 161 -174 221 -22 44
              -24 216 -4 343 12 83 17 93 57 138 53 60 92 135 130 252 24 75 31 87 50 87 27
              0 45 25 102 137 57 111 72 174 79 334 6 130 5 137 -16 158 -11 11 -32 21 -45
              21 -24 0 -24 1 -10 28 7 15 14 48 14 74 0 26 5 50 10 53 6 4 8 10 5 15 -3 4
              -2 16 1 25 5 13 8 14 15 3 8 -13 14 28 11 77 0 11 -3 81 -6 156 l-6 135 40 18
              c46 20 56 44 46 112 -9 65 -30 98 -82 129 -45 26 -46 29 -40 64 14 77 18 168
              9 201 -7 27 -17 37 -41 45 -24 8 -29 14 -22 25 14 22 12 30 -9 30 -10 0 -24 7
              -31 15 -7 8 -18 15 -25 15 -7 0 -15 7 -19 15 -6 17 -62 20 -86 5 -8 -5 -10
              -10 -5 -10 15 0 -18 -20 -34 -20 -11 0 -11 3 -1 15 11 13 10 14 -2 10 -22 -9
              -45 41 -30 65 11 18 9 19 -17 14 -28 -6 -29 -5 -36 45 -8 63 -29 89 -51 66
              -21 -21 -21 -20 -44 28 -11 23 -29 53 -40 67 l-19 25 6 -24 c6 -22 2 -21 -48
              16 -52 39 -119 78 -119 69 0 -2 20 -17 45 -33 25 -15 45 -32 45 -37 0 -5 -8
              -2 -18 7 -29 26 -38 20 -12 -8 13 -14 19 -25 14 -25 -5 0 -18 14 -29 30 -11
              16 -24 30 -28 30 -5 0 -33 20 -63 45 -31 24 -74 50 -97 56 -23 6 -107 12 -187
              14 -80 1 -156 6 -170 9 -24 6 -24 6 -2 -3z m399 -67 c-3 -3 -12 -4 -19 -1 -8
              3 -5 6 6 6 11 1 17 -2 13 -5z m827 -869 c3 -17 8 -49 12 -71 4 -25 2 -49 -5
              -60 -9 -15 -10 -10 -5 24 8 50 -1 56 -15 10 -9 -30 -10 -28 -4 12 8 58 7 90
              -2 115 -6 15 -5 17 3 10 7 -6 14 -24 16 -40z m56 -105 c0 -5 -5 -10 -11 -10
              -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-2383 -6055 c10 -82 17 -196
              16 -252 -2 -91 -5 -108 -32 -162 -17 -34 -34 -85 -37 -118 -4 -31 -15 -71 -25
              -88 -10 -16 -24 -57 -32 -90 -8 -33 -26 -85 -41 -116 -14 -31 -26 -64 -26 -74
              0 -9 -8 -34 -19 -54 -32 -63 -89 -184 -111 -236 -11 -27 -39 -79 -60 -115 -22
              -36 -51 -96 -65 -133 -14 -37 -47 -95 -73 -127 -43 -55 -50 -60 -86 -60 -76 0
              -254 -32 -421 -76 -93 -24 -264 -69 -380 -99 -115 -29 -259 -70 -320 -89 -60
              -19 -111 -34 -113 -32 -2 2 38 41 88 87 51 46 131 134 178 194 106 135 269
              304 467 483 218 198 784 768 826 832 81 123 105 187 149 410 31 157 56 263 67
              290 3 8 12 -39 19 -105 8 -66 22 -187 31 -270z m2832 106 c66 -266 89 -327
              146 -389 98 -110 500 -338 1240 -706 262 -131 502 -258 615 -326 186 -113 331
              -190 359 -190 8 0 58 -24 110 -53 53 -30 127 -71 166 -92 38 -21 64 -40 58
              -42 -6 -2 -152 16 -325 41 -390 56 -411 59 -808 96 -179 17 -379 38 -445 47
              -79 11 -205 17 -373 19 l-253 2 -39 44 c-21 25 -55 55 -75 69 -20 13 -47 45
              -61 72 -14 27 -46 76 -71 110 -25 34 -58 89 -73 122 -15 33 -34 66 -43 74 -10
              7 -17 20 -17 27 0 8 -11 35 -24 61 -42 81 -86 189 -86 209 0 10 -10 39 -21 64
              -12 25 -27 76 -35 113 -7 38 -24 88 -38 112 -45 82 -44 194 4 626 6 48 10 101
              10 120 0 67 19 10 79 -230z m3414 -3406 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15
              9 16 15 13 8 -4z m-66 -442 c-8 -7 -37 9 -31 19 3 5 12 4 20 -3 8 -6 13 -14
              11 -16z"
              />
              <path
                d="M11051 1121 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z"
              />
              <path
                d="M2260 950 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
              -4 -4 -4 -10z"
              />
            </g>
          </svg>
          NOVA VJEŽBAČICA
        </h3>

        <div class="input__group active__date">
          <CheckboxCustom
            :checkClass="'custom__check input__field client__active'"
            :label="'Aktivna'"
            :modelValue="clientInput.active"
            v-model="clientInput.active"
          />
          <div class="client__img_wrapper">
            <ClientPicture
              :picture="clientInput.picture"
              imgSize="6em"
              class="client__img"
            />
            <button @click.prevent="openCamera" class="action_btn client__add">
              <svg
                x="0px"
                y="0px"
                width="30px"
                height="30px"
                fill="var(--purple)"
                viewBox="0 0 569.859 569.858"
                style="enable-background: new 0 0 569.859 569.858"
                xml:space="preserve"
              >
                <path
                  d="M155.707,0c-21.239,0-38.422,17.212-38.422,38.441v492.976c0,21.238,17.184,38.441,38.422,38.441h258.427
                  c21.219,0,38.439-17.203,38.439-38.441V38.441C452.574,17.212,435.353,0,414.134,0H155.707z M284.274,546.392
                  c-13.368,0-24.203-10.815-24.203-24.184c0-13.359,10.834-24.184,24.203-24.184c13.331,0,24.184,10.824,24.184,24.184
                  C308.458,535.576,297.605,546.392,284.274,546.392z M400.689,453.521c0,5.843-4.744,10.586-10.586,10.586H179.728
                  c-5.843,0-10.586-4.743-10.586-10.586V74.004c0-5.843,4.743-10.576,10.586-10.576h210.375c5.842,0,10.586,4.733,10.586,10.576
                  V453.521z"
                />
                <path
                  d="M336.476,194.511h-55.242v0.966c0,1.711-1.396,3.108-3.089,3.108h-43.242c-1.711,0-3.088-1.396-3.088-3.108v-0.88
                  c-13.426,0.803-24.088,11.924-24.088,25.551V323.27c0,14.152,11.475,25.628,25.628,25.628h103.131
                  c14.143,0,25.627-11.476,25.627-25.628V220.138C362.103,205.986,350.619,194.511,336.476,194.511z M227.56,229.223
                  c-1.702,0-3.079-1.396-3.079-3.099v-9.706c0-1.712,1.386-3.098,3.079-3.098h43.251c1.702,0,3.089,1.396,3.089,3.098v9.706
                  c0,1.702-1.396,3.099-3.089,3.099H227.56z M284.906,318.689c-20.282,0-36.729-16.438-36.729-36.739
                  c0-20.282,16.447-36.72,36.729-36.72c20.281,0,36.738,16.438,36.738,36.72C321.644,302.251,305.187,318.689,284.906,318.689z"
                />
              </svg>
              Slika
            </button>
          </div>
        </div>

        <div class="input__group">
          <div class="input__field">
            <label for="first_name">Ime</label>
            <input
              type="text"
              name="first_name"
              placeholder="ime"
              required
              id="first_name"
              class="login_input user_input"
              v-model="clientInput.first_name"
            />
          </div>

          <div class="input__field">
            <label for="last_name">Prezime</label>
            <input
              type="text"
              id="last_name"
              placeholder="prezime"
              required
              class="login_input user_input"
              v-model="clientInput.last_name"
            />
          </div>
        </div>

        <div class="input__group">
          <div class="input__field">
            <label for="date_start">Datum upisa</label>
            <datepicker
              v-model="clientInput.date_started"
              placeholder="datum upisa"
              class="login_input user_input"
              :language="sr"
            >
            </datepicker>
          </div>

          <div class="input__field">
            <div class="termin">
              <label>Grupa / Termin :</label>
              <p class="client__schedule">
                {{ schedule.length ? schedule[0].title : '' }}
              </p>
              <p class="client__schedule">
                {{ schedule.length ? schedule[0].startTime : '' }}
              </p>
            </div>
          </div>
        </div>

        <div class="input__group">
          <div class="input__field">
            <label for="email">E-mail</label>
            <input
              type="email"
              id="email"
              placeholder="e-mail"
              required
              class="login_input user_input"
              v-model="clientInput.email"
            />
          </div>

          <div class="input__field">
            <label for="mobile">Mobilni</label>
            <input
              type="tel"
              id="mobile"
              placeholder="mobilni"
              required
              class="login_input user_input"
              v-model="clientInput.mobile"
            />
          </div>
        </div>

        <div class="input__group">
          <div class="input__field">
            <label for="instagram">Instagram</label>
            <input
              type="text"
              name="instagram"
              placeholder="instagram profil"
              id="instagram"
              class="login_input user_input"
              v-model="clientInput.instagram"
            />
          </div>

          <div class="input__field">
            <label for="facebook">Facebook</label>
            <input
              type="text"
              id="facebook"
              placeholder="facebook profil"
              class="login_input user_input"
              v-model="clientInput.facebook"
            />
          </div>
        </div>

        <div class="input__group">
          <div class="input__field">
            <label for="notes">Napomene</label>
            <textarea
              name="notes"
              id="notes"
              cols="20"
              rows="5"
              placeholder="napomene"
              class="login_input user_input"
              v-model="clientInput.notes"
            >
            </textarea>
          </div>
          <!-- <div class=""> -->
          <div v-if="getOneClient._id" class="">
            <button
              type="submit"
              @click.prevent="newClient()"
              class="action_btn client__add"
            >
              <svg
                version="1.1"
                id="Layer_1"
                x="0px"
                y="0px"
                viewBox="0 0 1964.601 1689.422"
                enable-background="new 0 0 1964.601 1689.422"
                xml:space="preserve"
                fill="var(--purple)"
                width="40px"
                height="40px"
              >
                <path
                  d="M596.675,46.812c2.36-2.565,11.24-5.634,12.609,8.424c0.289,3.583,0.834,7.15,1.884,10.597  c1.956-0.713,3.936-1.395,5.892-2.148c11.556,4.307,15.511,36.37,17.522,49.152c0.721,0.818,1.571,1.491,2.413,2.204  c0.729-9.579-1.226-19.061-1.379-28.6c-0.573-4.957,8.226-9.497,11.935,0.609c6.968,20.253,5.029,31.218,10.525,44.84  c4.736,12.226-3.164,40.206-9.507,53.24c-9.106,17.067-20.544,262.231-24.368,279.683c-2.781,7.695-8.745,14.084-10.108,22.348  c-2.593,17.2-43.237,155.024-44.784,159.664c-31.418,87.699-38.43,97.082,32.792,166.405c8.421,8.278,22.406,10,38.78,31.766  c5.416,6.775,13.147,8.325,14.148,9.018c8.823,12.217,12.337,9.556,18.588,18.308c3.976,6.132,10.292,10.116,15.919,14.564  c1.025,1.01,18.607,29.446,55.292,50.571c27.807,18.446,36.522,13.271,47.285,20.055c3.431,2.381,7.767,1.034,11.647,1.419  c62.12-2.905,233.522,48.618,331.8,124.732c1.001,0.716,149.599,112.289,162.806,121.734c94.163,62.009,77.08,1.408,297.966,144.514  c1.006,0.564,25.427,13.771,37.385,23.478c29.688,24.821,19.388,4.573,60.615,40.391c1.9,1.9,4.745,0.802,7.118,1.403  c6.22,1.972,11.952,5.186,18.164,7.214c2.661,1.836,3.375,5.395,5.09,8.032c4.048,0.633,7.431,3.086,11.23,4.481  c12.152,4.6,4.614,7.565,19.991,7.735c3.623-3.639,6.252-8.104,9.795-11.807c22.577-21.136,47.308-3.464,28.079,22.444  c8.163,7.794,22.197,3.408,37.569,18.268c27.128,26.765,61.768,6.157,77.519,45.048c11.28,30.321-8.236,58.75-28.952,83.66  c-3.744,4.416-1.505,7.441-19.703,14.885c-2.252,0.89-3.639-1.427-4.777-2.878c-37.417,2.948-29.395-28.097-45.609-32.039  c-2.255,5.811-12.012,27.69-20.24,28.448c0.825,0.761,1.659,1.563,2.485,2.405c-1.579,1.026-3.142,2.068-4.689,3.134  c0.52,4.644,1.206,2.639-9.523,18.388c-1.202-0.369-2.308-0.721-3.391-1.202c0.233,1.523,0.441,3.07,0.665,4.641  c-0.401,0.24-1.202,0.713-1.603,0.954c-1.547,2.677-3.311,5.234-5.154,7.719h-37.746c-0.369-1.611-0.681-3.222-0.938-4.825  c-13.507-8.022-20.228-22.226-21.602-29.898c-7.509-27.867-23.106-28.622-27.83-31.381c-2.704-1.541-14.573-13.786-7.078,8.513  c-0.849-1.876-1.627-3.759-2.349-5.651c-1.988,0.417-4.569,0.273-5.667,2.325c0.361,6.284,5.395,11.286,5.515,17.683  c0.397,7.816-7.246,5.933-9.787,0.457c-2.092-3.535-2.365-7.855-4.617-11.27c-2.939-0.992-21.327-2.144-15.775-20.809  c4.017-13.153,5.565-14.124,4.865-17.234c-1.011-1.012-10.21-9.586-16.937-9.298c-4.571,15.754,2.182,31.419,2.461,41.193  c-0.425-0.104-1.274-0.297-1.699-0.393c-8.353-35.231-1.981-25.612-3.791-37.145c-6.115,0.422-69.448-11.679-70.45-11.807  c-263.367-26.693-242.865-89.941-531.35-128.828c-53.383-13.928-143.985-20.266-215.974-68.43  c-121.606-68.334-146.16-177.279-261.575-200.287c-1.403-0.649-2.413-1.844-3.551-2.822c-7.414-0.89-14.019-4.769-20.881-7.447  c-2.757,0.914-4.825,3.535-8,3.174c-5.272-12.573-5.926-4.211-13.57-6.597c-4.144-1.194-8.954-2.172-11.03-6.421  c-9.597,0.932-30.588-7.967-34.179-9.579c-0.417-0.77-0.818-1.523-1.218-2.26c-1.82-0.104-3.639-0.233-5.443-0.337  c-0.008-0.385-0.016-1.154-0.024-1.539l-0.313,1.066c-9.71-4.07-8.972-0.616-13.57-2.012c-15.676-4.887-2.716-8.139-25.778-12.472  c-0.199,27.765-30.094,501.303-55.541,508.185c-13.192,5.396-25.96,15.656-28.119,17.691c-6.204,4.849-14.116,6.933-20.36,11.703  c-4.409,4.369-11.134,5.443-17.081,4.914c-0.585-4.136-2.341-8.056-2.525-12.224c1.058-4.321,4.577-7.575,5.563-11.959  c-22.464-2.678-89.33,37.46-91.627,21.482c1.72-7.911,14.761-12.244,16.552-17.073c-7.854,0.131-30.579,10.333-38.828,4.833  c-1.571-2.565-0.12-5.386,1.09-7.719c3.647-1.162,8.585-1.371,9.851-5.739c-3.086-1.884-5.707-6.012-3.31-9.426  c6.289-4.924,20.995-2.062,24.023-14.388c43.17-23.597,36.432-25.708,60.951-21.819c6.582,1.009,41.477-5.557,43.148-6.421  c11.737-9.028,10.149-14.411,11.19-17.779c4.688-15.555-6.377-99.167-13.779-131.305c-28.088-134.324,31.38-89.06-15.879-324.626  c-9.995-93.178,23.369-86.102-2.605-123.032c-1.387,0.12-2.749,0.264-4.128,0.401c-3.902-33.365,5.086-33.409-1.09-39.325  c-7.858-1.072-20.208,2.593-43.493,2.95c-1.948,5.098-3.968,10.188-6.918,14.813c-0.762-5.21-0.337-10.901-3.359-15.494  c-0.001,0.002-8.705,23.55-8.705,23.55c0.353,5.403,3.519,10.541,2.325,16.047c-0.585,3.519-2.493,6.717-2.717,10.3  c0.409,3.607,2.333,6.877,2.445,10.549c0.782,6.287-2.74,5.065,6.581,21.642c3.045,5.731,6.971,27.447,6.549,40.038  c-0.27,11.072,8.983,21.817-0.192,40.407c-0.521-2.485-0.705-5.01-0.89-7.511c-8.087,1.14-3.4,6.522-8.08,10.076  c-10.128,8.678-5.054,8.09-22.548,10.549c-0.048-0.729-0.16-2.188-0.208-2.918c-4.264,1.547-9.755,2.613-11.334,7.535  c-2.02-0.096-4.04-0.216-6.044-0.385c0.064-3.807,2.188-7.03,3.214-10.565c-0.04-3.647,0.521-7.262,2.373-10.461  c1.082-0.786,2.541-1.29,3.222-2.501c1.515-5.948,1.675-12.12,1.218-18.203c0.042-21.855,7.475-55.316,9.178-64.855  c0.633-3.198-1.659-5.924-2.124-8.961c-1.002-3.671-0.481-8-3.23-10.982c-5.226-6.308-9.018-13.987-9.418-22.284  c-8.857-1.798-9.145-6.594-10.004-10.613c-1.13-0.505-2.252-0.994-3.375-1.483c10.82-12.168,18.452-10.824,8.112-31.878  c-15.022-7.297-2.314-4.133-22.933-9.443c-1.299,0.248-2.605,0.497-3.904,0.745c-5.3-3.786-3.076-3.508-11.238-3.984  c-3.67-5.549-0.309-0.169-12.048-6.132c-1.627,0.609-2.926,2.068-4.697,2.228c-2.894-1.09-4.248-4.08-5.611-6.605  c-3.639-1.635-7.623-2.533-11.527-3.318c-0.305-0.256-0.922-0.753-1.226-1.01c-3.262-0.208-6.645-0.93-9.066-3.286  c-2.052-2.236-5.282-1.723-7.927-2.581c-1.595-0.377-1.707-2.284-2.405-3.479c-2.749-1.86-5.298-4.016-7.463-6.541  c-2.805-4-7.871-4.97-11.799-7.487c-1.408-4.661-3.152-13.1-9.955-24.568c-3.34-5.475,0.765-6.727-6.324-9.771  c-1.804-3.607-3.888-7.174-4.328-11.27c-0.377-3.399-3.767-5.531-4.144-8.905c-0.064-2.701,2.733-4.16,3.527-6.517  c4.535-29.505,5.384-40.36,20.216-54.667c3.214-4.505,4.2-10.316,8.04-14.428c1.523-1.611,2.509-3.607,3.278-5.659  c3.647-2.028,7.847-4,9.875-7.839c14.957-7.945,25.402-11.799,25.402-11.799c2.272-12.169,6.269-4.194,10.533-9.002  c2.349-2.381,5.459-3.695,8.729-4.216c8.679-13.49,28.982,1.227,38.547,0.208c9.519-1.336,19.818,14.349,34.668,7.35  c1.771-0.914,3.174,0.906,4.609,1.683c3.663,2.765,8.593,1.667,12.737,3.086c4.793,2.212,8.344,6.348,13.009,8.793  c1.651,2.757,3.102,5.683,5.387,7.992c2.95,6.145,7.953,3.058,14.124,11.783c3.399,4.817,8.938,7.607,12.128,12.609  c8.635,10.008,2.354,4.237,13.226,10.092c-1.122,0.826-2.26,1.643-3.383,2.469c0.794,2.317,3.022,3.399,4.745,4.922  c1.21,1.507,1.443,3.735,2.998,4.986c1.78,0.649,4.12-0.874,5.547,0.834c7.179,7.206,8.356,3.09,7.214,11.086  c1.667,2.91,4.248,5.09,7.27,6.517c0.152,0.521,0.465,1.563,0.617,2.084c3.062,1.659,6.573,1.571,9.955,1.715  c-0.289,0.938-0.585,1.884-0.858,2.838c1.852,3.294,2.95,7.302,6.405,9.354c3.343,2.14,5.908,5.827,10.052,6.437  c24.673,3.596,28.456-4.668,38.251-13.322c0.729-1.779,0.641-3.831,1.547-5.523c1.371-0.553,2.838-0.81,4.28-1.162  c1.147-12.043,18.42-3.877,20.472-7.903c0.625-1.347,0.593-2.87,0.818-4.296c-14.378-15.705,11.228-65.06,21.546-84.661  c0.332-0.285,29.897-50.534,35.87-57.12c32.929-37.193,71.263-142.572,71.508-176.625c2.371-58.963,54.254-160.567,48.262-267.627  c-4.523-28.298-60.953-66.095-61.953-67.091c-1.619-1.491-0.713-3.936-0.89-5.851c20.98-12.6,34.454,16.801,52.607,16.023  c8.785-3.111-1.756-70.472,10.725-75.98c3.391-2.052,6.805,1.082,9.875,2.341C594.23,51.926,594.583,48.872,596.675,46.812   M1316.434,1350.111c3.27,11.802,84.16,33.677,94.929,33.578C1403.416,1372.044,1331.87,1350.153,1316.434,1350.111   M1766.345,1433.001c-2.429,2.669-5.771,5.419-5.443,9.426c9.608,0.611,6.199,3.229,10.701,4.585  c15.014,5.129,9.494,2.344,16.569,3.92c9.379,2.249,14.285-29.369-1.651-27.43  C1778.641,1422.853,1771.563,1427.551,1766.345,1433.001 M1515.88,1426.436c0.096,4.124,60.245,29.364,67.043,28.752  c9.385,8.823,19.482,11.679,20.969,11.831c19.201,3.386,16.882,7.535,28.728,8.401c10.682,1.489,8.606,9.804,14.436,12.985  c0.754,0.358,18.792,5.918,20.095,5.907c4.144-3.864,9.466-6.204,14.941-7.503c-0.304-1.146-0.369-2.437-1.387-3.142  c-10.583-8.674-10.571-5.593-15.174-3.815C1664.531,1479.545,1529.309,1420.701,1515.88,1426.436 M1645.437,1574.959  c0.048,3.359-0.401,6.998,1.162,10.124c1.731,2.926,6.332,3.679,8.922,1.451c-0.521-4.032,0.112-8.288-1.78-12.024  c-3.217-6.842,1.567-12.032-4.345-14.22C1647.384,1564.947,1645.333,1569.781,1645.437,1574.959 M1662.943,1578.542  c0.866-0.898,1.747-1.787,2.637-2.669c-1.092-9.089-1.879-11.184-4.32-12.024  C1659.679,1567.236,1660.673,1575.655,1662.943,1578.542z"
                />
              </svg>
              <p>Aktivnosti</p>
            </button>
          </div>
          <!-- </div> -->
        </div>

        <div class="modify_btns">
          <action-buttons toForm="clients" />
          <delete-button
            @clicked="delClient()"
            v-if="!clientAttendances.length && !clientPayments.length"
          />

          <tooltip
            class="client__tooltip"
            tip="Klijent NE smije imati evidencija ili plaćanja da bi ga mogla obrisati."
          />
        </div>
      </form>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/components/utils/Loading.vue';
import ClientPicture from '@/components/utils/ClientPicture.vue';
import ActionButtons from '@/components/utils/ActionButtons.vue';
import DeleteButton from '@/components/utils/DeleteButton.vue';
import Tooltip from '@/components/utils/Tooltip.vue';
import CheckboxCustom from '@/components/utils/CheckboxCustom.vue';
import actionsNotify from '@/mixins/actionsNotify';
import mapSchedules from '@/mixins/mapSchedules';
import Datepicker from 'vuejs-datepicker';
import { sr } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'Client',

  components: {
    Loading,
    ClientPicture,
    Datepicker,
    ActionButtons,
    DeleteButton,
    Tooltip,
    CheckboxCustom,
  },

  mixins: [actionsNotify, mapSchedules],

  data() {
    return {
      enterClient: false,
      sr: sr,
      schedule: '',
      clientAttendances: [],
      clientPayments: [],
      clientInput: {
        //_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        mobile: '',
        address: '',
        date_started: new Date(),
        notes: '',
        picture: '',
        active: '',
      },
      appeared: false,
      isCamera: false,
    };
  },

  computed: {
    ...mapGetters([
      'getAllClients',
      'getOneClient',
      'getAllSchedules',
      'getAllAttendances',
      'getAllPayments',
      'getErrors',
      'loadingState',
    ]),
  },

  methods: {
    ...mapActions([
      'clientAdd',
      'clientUpdate',
      'clientDelete',
      'fetchSchedules',
      'fetchAttendances',
      'fetchPayments',
      'fetchClients',
      'fetchFromForm',
      'clearErrors',
      'setLoadingState',
    ]),

    handleCam() {
      this.isCamera = false;
    },

    async addClient() {
      this.setLoadingState(true);
      if (this.getOneClient._id) {
        await this.clientUpdate(this.clientInput);
        await this.fetchClients();
      } else {
        await this.clientAdd(this.clientInput);
      }
      this.setLoadingState(false);
      if (this.getErrors.length) {
        this.$toast.error(
          'Greška! ' + this.getErrors,
          'OK',
          this.notificationSystem.options.error
        );
        this.clearErrors();
      } else {
        this.$toast.success(
          'Uspješno sačuvano!',
          'OK',
          this.notificationSystem.options.success
        );
        this.$router.push('/clients');
      }
    },

    async delEx() {
      await this.clientDelete(this.getOneClient);
      this.$toast.success(
        'Uspješno obrisano!',
        'OK',
        this.notificationSystem.options.success
      );
      this.$router.push('/clients');
    },

    mapAttendances() {
      let obj,
        arr = [];
      for (let i = 0; i < this.getAllAttendances.length; i++) {
        for (let j = 0; j < this.getAllAttendances[i].members.length; j++) {
          obj = {
            client: this.getAllAttendances[i].members[j].client,
          };
          arr.push(obj);
        }
      }
      return arr;
    },

    mapPayments() {
      let obj,
        arr = [];
      for (let i = 0; i < this.getAllPayments.length; i++) {
        for (let j = 0; j < this.getAllPayments[i].members.length; j++) {
          obj = {
            client: this.getAllPayments[i].members[j].client,
          };
          arr.push(obj);
        }
      }
      return arr;
    },

    async newClient() {
      this.setLoadingState(true);
      this.fetchFromForm('client');
      this.$router.push('/clientactivity');
    },

    async openCamera() {
      this.setLoadingState(true);
      this.fetchFromForm('client');
      this.$router.push('/camera');
    },

    onAppeared() {
      this.appeared = true;
    },
  },

  async mounted() {
    if (this.getOneClient) {
      this.clientInput = this.getOneClient;
      if (!this.getOneClient.date_started) {
        this.clientInput.date_started = new Date();
      }
      if (!this.getAllSchedules.length) await this.fetchSchedules();
      this.schedule = this.mapSchedules().filter((post) => {
        return post.client._id == this.getOneClient._id;
      });
      if (!this.getAllAttendances.length) await this.fetchAttendances();
      this.clientAttendances = this.mapAttendances().filter((post) => {
        return post.client._id == this.getOneClient._id;
      });
      if (!this.getAllPayments.length) await this.fetchPayments();
      this.clientPayments = this.mapPayments().filter((post) => {
        return post.client._id == this.getOneClient._id;
      });
    }
    this.setLoadingState(false);
  },
};
</script>

<style>
.client__img_wrapper {
  display: flex;
  align-items: center;
  margin: 1em 0;
  gap: 1em;
}

.client__img {
  transition: all 0.4s ease;
}

.client__img:hover {
  transform: scale(1.5);
}

.client__img:active {
  transform: scale(1.5);
}

.client__active {
  align-self: center;
}

.client__schedule {
  margin-left: 0.5em !important;
}
</style>
